module.exports = __webpack_public_path__ + "assets/img/pic2.18776225.png";